import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GroupInfoFragment = { __typename?: 'CollectionAssetsGroup', id?: string | null, endCursor?: string | null, values?: Array<{ __typename?: 'CollectionAssetsSortValue', id?: string | null, value?: { __typename?: 'DateFieldValue', date?: string | null } | { __typename?: 'DerivedFieldValue', derived?: string | null } | { __typename?: 'JsonFieldValue', json?: string | null } | { __typename?: 'LinkFieldValue', link?: string | null } | { __typename?: 'LongTextFieldValue', longText?: string | null } | { __typename?: 'NumberFieldValue', number?: number | null } | { __typename?: 'RatingFieldValue', rating?: number | null } | { __typename?: 'SelectFieldValue', selectedOptions?: Array<string> | null } | { __typename?: 'SelectMultiFieldValue', multiSelectedOptions?: Array<string> | null } | { __typename?: 'TextFieldValue', text?: string | null } | { __typename?: 'ToggleFieldValue', toggle?: boolean | null } | { __typename?: 'UrlFieldValue', url?: string | null } | { __typename?: 'UserMultiFieldValue' } | { __typename?: 'UserSingleFieldValue', singleSelectedMember?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', id: string } | { __typename?: 'UserSelectMemberValue', id: string } | null> | null } | { __typename?: 'UsersFieldValue', selectedMembers?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', id: string } | { __typename?: 'UserSelectMemberValue', id: string } | null> | null } | null }> | null };

export const GroupInfo = /*#__PURE__*/ gql`
    fragment GroupInfo on CollectionAssetsGroup {
  id
  endCursor
  values {
    id
    value {
      ... on DerivedFieldValue {
        derived
      }
      ... on JsonFieldValue {
        json
      }
      ... on LinkFieldValue {
        link
      }
      ... on LongTextFieldValue {
        longText
      }
      ... on NumberFieldValue {
        number
      }
      ... on RatingFieldValue {
        rating
      }
      ... on SelectFieldValue {
        selectedOptions
      }
      ... on SelectMultiFieldValue {
        multiSelectedOptions
      }
      ... on TextFieldValue {
        text
      }
      ... on ToggleFieldValue {
        toggle
      }
      ... on UsersFieldValue {
        selectedMembers {
          id
        }
      }
      ... on UserSingleFieldValue {
        singleSelectedMember {
          id
        }
      }
      ... on DateFieldValue {
        date
      }
      ... on UrlFieldValue {
        url
      }
    }
  }
}
    ` as unknown as DocumentNode<GroupInfoFragment, unknown>;

        

        
export const useGroupInfoFragment = (
  input: string | Omit<UseFragmentOptions<GroupInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'CollectionAssetsGroup' } };
    return input;
  })();

  return useFragment<GroupInfoFragment>({
    fragment: GroupInfo,
    fragmentName: 'GroupInfo',
    ...options,
  });
};
  
        